import { render, staticRenderFns } from "./indicadores.vue?vue&type=template&id=95f4df1a&scoped=true&"
import script from "./indicadores.vue?vue&type=script&lang=js&"
export * from "./indicadores.vue?vue&type=script&lang=js&"
import style0 from "./indicadores.vue?vue&type=style&index=0&id=95f4df1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f4df1a",
  null
  
)

export default component.exports